import React from 'react';
import { Box, VStack, Heading } from '@chakra-ui/react';
import ReportingTab from '../components/ReportingTab';

/**
 * Halaman Retail Integration Data: duplikasi fungsi Reporting dari /retail/ieem,
 * namun API mengembalikan semua data tanpa filter diskon/Injourney Besties.
 * Filter di front end tetap sama seperti halaman Reporting.
 */
const RetailIntegrationData = () => {
  return (
    <Box>
      <VStack align="stretch" spacing={4} mb={6}>
        <Heading size={{ base: 'md', lg: 'lg' }} color="gray.700">
          Retail – Integration Data (Semua Transaksi)
        </Heading>
      </VStack>
      <ReportingTab allData={true} />
    </Box>
  );
};

export default RetailIntegrationData;
